// extracted by mini-css-extract-plugin
export var cardWrapper = "_8p-0";